import styled from 'styled-components';

export const Skeleton = styled.div`
  display: flex;
  flex-direction: column;
`;
